import api from '@/apis/fixedAsset/fAPurchaseIncrementAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('approveVoucherFAPurchaseIncrementList', api);

const state = {
  ...crud.state,
  _config: {
    table: '',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
